// extracted by mini-css-extract-plugin
export default {"value":"BattleTypePicker_value_d780f","battleTypeIcon":"BattleTypePicker_battleTypeIcon_e9a92","item":"BattleTypePicker_item_f27ef"};